import * as React from 'react';

const Selected = (): JSX.Element => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      style={{ fill: 'none' }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.667969"
        y="0.667969"
        width="15.3333"
        height="15.3333"
        rx="2"
        fill="#72BF40"
      />
      <path
        d="M12.4259 5.52148L6.80094 11.1464L4.24414 8.58964"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export { Selected };



// WEBPACK FOOTER //
// ./src/components/svg/Selected.tsx